import React, { Children } from 'react';
import { StyleSheet, View } from 'react-native'
import { Tooltip, Text } from 'react-native-elements'
import Modal from './web/Overlay'
import ModalE from 'modal-enhanced-react-native-web';
import TextZ from './TextZ';

export default class Hint extends React.Component {
    state = {
        open: false,
        isOpen: false,
    }
    constructor(props) {
        super(props);
        // this.tooltipRef = React.createRef();
    }

    static getDerivedStateFromProps(props, state) {
        if (props.open && !state.open) {
            return { open: props.open };
        }

        return {}
    }

    componentDidUpdate() {
        if (this.state.open !== this.state.isOpen) {
            // this.tooltipRef.current.toggleTooltip();
        }
    }

    hint() {
        const  { width, height, message } = this.props
        return <View style={{
                height: 0,
                width: 0,
                position: 'absolute',
                zIndex: 10000,
                overflow: 'visible',
            }}>
            <View style={{
                width, 
                backgroundColor: 'rgba(255,255,200,0.8)',
                height,
                margin: 10,
                borderRadius: 8, 
                padding: 8
                }}>
                <TextZ>{message}</TextZ>
            </View>
        </View>
    }

    render () {
        const  { children, message, open, ...props } = this.props
        return <View>
            <View>
                {children}
            </View>
            {open ? this.hint() : null}
        </View>
    }

    // render() {
    //     const  { children, message, open, ...props } = this.props
// 
    //     return <Tooltip 
    //         {...props}
    //         overlayColor='#ff0000'
    //         ModalComponent={ModalE}
    //         popover={<Text>{`${message} ${open ? 'OPEN':'CLOSE'} ${JSON.stringify(this.state)}`}</Text>}
    //         ref={this.tooltipRef}
    //         onOpen={() => this.setState({ isOpen: true })}
    //         onClose={() => this.setState({ isOpen: false })}
    //     >
    //         {children}
    //     </Tooltip>
    // }
  
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
    },
    text: { 
        textAlign: 'center', 
        alignSelf: 'center',
        flex: 1,
        fontSize: 20,
        color: 'white'
    }
});
  
  